export enum TradeFinanceType {
  LOAN = 'Loan',
  LEASE = 'Lease',
}

export enum TradePayoffFields {
  FINANCE_TYPE = 'financeType',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  PHONE_NUMBER = 'customerPhoneNumber',
  ADDRESS = 'customerAddress',
  VIN = 'vin',
  LENDER = 'lenderName',
  LENDER_ID = 'lenderId',
  ACCOUNT_NUMBER = 'accountNumber',
  BIRTH_DATE = 'customerBirthdate',
  SSN = 'socialSecurityNumber',
}

export interface TradePayoffFormData {
  [TradePayoffFields.FINANCE_TYPE]: TradeFinanceType;
  [TradePayoffFields.FIRST_NAME]: string;
  [TradePayoffFields.LAST_NAME]: string;
  [TradePayoffFields.PHONE_NUMBER]: string;
  [TradePayoffFields.ADDRESS]: string;
  [TradePayoffFields.VIN]: string;
  [TradePayoffFields.LENDER]: string;
  [TradePayoffFields.LENDER_ID]: string;
  [TradePayoffFields.ACCOUNT_NUMBER]?: string;
  [TradePayoffFields.BIRTH_DATE]?: Date;
  [TradePayoffFields.SSN]?: string;
}

export const TRADE_PAYOFF_FIELD_DISPLAY = {
  [TradePayoffFields.FINANCE_TYPE]: 'Trade Finance Type',
  [TradePayoffFields.FIRST_NAME]: 'First Name',
  [TradePayoffFields.LAST_NAME]: 'LastName',
  [TradePayoffFields.PHONE_NUMBER]: 'Phone',
  [TradePayoffFields.ADDRESS]: 'Street Address',
  [TradePayoffFields.VIN]: 'VIN',
  [TradePayoffFields.LENDER]: 'Lender/Lease Company',
  [TradePayoffFields.LENDER_ID]: 'Lender ID',
  [TradePayoffFields.ACCOUNT_NUMBER]: 'Loan/Lease Account Number',
  [TradePayoffFields.BIRTH_DATE]: 'Birth Date',
  [TradePayoffFields.SSN]: 'Social Security Number',
};
